import { Link } from 'react-router-dom';
import { formatChatTime } from '../travelChatModel';
import { memberFallbackLabel } from '../../member-display/memberDisplayModel';
import {
  BALANCE_RENDERER_KEY,
  CARD_SCHEMA_V1,
  cardFallbackText,
  cardSchemaVersion,
  isSupportedCardSchema,
  normalizeBalanceBusinessCard,
} from './travelCardModel';

const UNSUPPORTED = '此卡片目前無法顯示';

export default function BalanceCardMessage({ message }) {
  const card = normalizeBalanceBusinessCard(message?.businessCard);
  if (!card || card.rendererKey !== BALANCE_RENDERER_KEY) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, UNSUPPORTED)}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }
  if (!card.journeyId || !card.totalLabel) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }

  const calculated = formatChatTime(card.calculatedAt) || String(card.calculatedAt || '').replace('T', ' ');

  return (
    <article className="travel-msg-card" aria-label="旅程分帳">
      <p className="travel-msg-card__kicker">旅程分帳</p>
      <h2 className="travel-msg-card__title">目前分帳摘要</h2>
      <p>{card.calculationStatusLabel || '依目前支出計算'}</p>
      <p className="travel-msg-card__amount">{card.totalLabel}</p>
      {card.participantCount != null ? <p>參與人數：{card.participantCount}</p> : null}
      {card.receivableCount != null || card.payableCount != null ? (
        <p>
          應收 {card.receivableCount ?? 0} 人 · 應付 {card.payableCount ?? 0} 人
          {card.balancedCount ? ` · 已平衡 ${card.balancedCount} 人` : ''}
        </p>
      ) : null}
      {card.members.length > 0 ? (
        <ul className="travel-msg-card__list">
          {card.members.map((row) => (
            <li key={row.memberId}>
              {memberFallbackLabel(row.memberId)}
              {' · '}
              {row.kindLabel}
              {' '}
              {row.netLabel}
              {row.currencyCode ? ` ${row.currencyCode}` : ''}
            </li>
          ))}
        </ul>
      ) : null}
      {card.remainingMemberCount > 0 ? <p>另有 {card.remainingMemberCount} 位旅伴未列出</p> : null}
      {calculated ? <p><time dateTime={card.calculatedAt}>{calculated}</time></p> : null}
      {card.calculationVersion != null ? <p>計算版本：{card.calculationVersion}</p> : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看分帳
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
